import React, { useContext, useEffect, useState } from "react";

//imagenes
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import usuariosIcon from "../../assets/img/usuarios.svg";
import { useParams, useNavigate } from "react-router-dom";
import ConexContext from "../../context/ConexContext";
import ModalCambioPass from "../modales/ModalCambioPass";
import { formatFecha } from "../JS/formato";
import ModalGenericoUsuario from "../modales/ModalGenericoUsuario";

const PerfilUsuario = ({ nuevo }) => {
	const { peticion, tipo_usuario, id_usuario } = useContext(ConexContext);
	const { usuario } = useParams();
	const navigate = useNavigate();

	const [datosUsuCopy, setDatosUsuCopy] = useState(null); //datos del usuario copia
	const [datosUsu, setDatosUsu] = useState(null); //datos del usuarioo
	const [datosTarj, setDatosTarj] = useState(null); //datos de tarjetas
	const [datosEntidades, setDatosEntidades] = useState(null); //datos de las entidades
	const [datosEmpresas, setDatosEmpresas] = useState(null); //datos de las empresas
	const [datosDepartamentos, setDatosDepartamentos] = useState(null); //datos de los departamentos

	const [mensaje, setMensaje] = useState(null); //mensaj
	const [error, setError] = useState(null); //mensaje de error
	
	const [modalCambioPass, setModalCambioPass] = useState(false); //modal cambio contraseña
	const [modalEliminar, setModalEliminar] = useState(false); //modal eliminar usuario
	const [modalCrear, setmodalCrear] = useState(false); //modal crear usuari
	const [modalModificar, setmodalModificar] = useState(false); //modal modificar usuario
	const [modalReset, setmodalReset] = useState(false); //modal resetear contraseña

	/**
	 * Obtiene los datos del usuario. Si es nuevo, carga los datos por defecto vacíos
	 */
	useEffect(() => {
		const datos_usuario = async () => {
			setMensaje(null);
			let res = await peticion(`/datos_usuario?usuario=${usuario}`, {
				method: "GET",
			});
			if (res?.estado ?? true) return setMensaje("Se ha producido un error");
			if (res?.res ?? false) {
				setDatosUsu(res["res"]);
				setDatosUsuCopy(res["res"]);
			} else {
				setMensaje(res?.mensaje ?? "Error al cargar los datos del usuario");
			}
		};
		//si es nuevo usuario
		if (nuevo)
			return setDatosUsu({
				cod_dpto: "",
				cod_emp: "",
				cod_ent: "",
				cod_usuario: "",
				email: "",
				fecha_alta_usu: "",
				nif_usuario: "",
				nombre_usuario: "",
				password: "",
				tipo_usuario: "",
			});
		
		//si estoy consultando un usuario
		if ( usuario && (tipo_usuario === "5" || tipo_usuario === "2" || tipo_usuario === "3" || tipo_usuario === "0" || tipo_usuario === "1" || id_usuario === usuario))
			datos_usuario();
		//si no, muestra mensaje de error
		else setMensaje("No tienes permisos para ver este usuario");
	}, [usuario, tipo_usuario, id_usuario, peticion, nuevo]);

	/**
	 * Obtiene los datos de las tarjetas del usuario
	 */
	useEffect(() => {
		const listado_tarjetas = async () => {
			let res = await peticion(`/listado_tarjetas_usuario?usuario=${usuario}`, { method: 'GET' });
			if (res?.estado ?? true) return;
			if (res?.res ?? false) {
				setDatosTarj(res["res"]);
			}
		}
		if(usuario)
			listado_tarjetas();
	}, [peticion, usuario]);

	/**
	 * Obtiene los datos de las entidades, empresas y departamentos para los selects
	 */
	useEffect(() => {
		const datos_selects = async () => {
			peticion(`/distinc_select`, {
				method: "POST",
				json: {
					"campos": ["cod_ent", "nombre_ent"],
					"tabla": "i6entidad"
				},
			})
			.then(res => {
				if (res?.estado ?? true) return setMensaje("Se ha producido un error");
				if (res?.res ?? false) setDatosEntidades(res["res"]["res"]);
			})
			.catch(error => {
				setMensaje("Se ha producido un error");
			});

			peticion(`/distinc_select`, {
				method: "POST",
				json: {
					"campos": ["cod_ent", "cod_emp", "nombre_emp"],
					"tabla": "i6empresa"
				},
			})
			.then(res => {
				if (res?.estado ?? true) return setMensaje("Se ha producido un error");
				if (res?.res ?? false) setDatosEmpresas(res["res"]["res"]);
			})
			.catch(error => {
				setMensaje("Se ha producido un error");
			});

			peticion(`/distinc_select`, {
				method: "POST",
				json: {
					"campos": ["cod_ent", "cod_emp", "cod_dpto", "nombre_dpto"],
					"tabla": "i6departamento"
				},
			})
			.then(res => {
				if (res?.estado ?? true) return setMensaje("Se ha producido un error");
				if (res?.res ?? false) setDatosDepartamentos(res["res"]["res"]);
			})
			.catch(error => {
				setMensaje("Se ha producido un error");
			});
		};
		datos_selects();
	}, [peticion]);

	/**
	 * Obtiene las diferencias entre dos objetos
	 * @param {Object} obj1 Objeto 1
	 * @param {Object} obj2 Objeto 2
	 * @returns {Object} objeto con las diferencias entre obj1 y obj2
	 */
	const getDiferentes = (obj1, obj2) => {
		const diferentes = {};
		for (const key in obj2) {
			if (obj1[key] !== obj2[key]) {
				diferentes[key] = obj2[key];
			}
		}
		return diferentes;
	};
	
	/**
	 * Comprueba si todos los campos están rellenos
	 * @returns {boolean} true si todos los campos están rellenos, false si no
	 */
	const comprobarCampos = () => {
		//comprobar si tengo todos los campos
		if (
			!datosUsu.cod_usuario ||
			!datosUsu.nombre_usuario ||
			!datosUsu.nif_usuario ||
			!datosUsu.cod_ent ||
			!datosUsu.cod_dpto ||
			!datosUsu.cod_emp ||
			!datosUsu.email ||
			!datosUsu.tipo_usuario
		) {
			setError("Faltan campos por rellenar");
			return false;
		}
		//comprobar si el email es correcto
		if (!/^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/.test(datosUsu.email)) {
			setError("El email no es correcto");
			return false;
	}
		//comprobar si el nif es correcto
		if (!/^\d{8}[a-zA-Z]$/.test(datosUsu.nif_usuario)) {
			setError("El NIF no es correcto");
			return false;
		}
		//comprobar si el codigo de usuario tiene espacios
		if (datosUsu.cod_usuario.includes(" ")) {
			setError("El código de usuario no puede contener espacios");
			return false;
		}
		setError(null);
		return true;
	};

	/**
	 * Modifica los datos del usuario
	 * @returns 0 si todo ha ido bien, otra cosa si ha habido algún error
	 */
	const modUsu = async () => {
		let diferencias = getDiferentes(datosUsuCopy, datosUsu);
		if (Object.keys(diferencias).length === 0) return;
		const res = await peticion(`/guardar_datos_usuario`, {
			method: "POST",
			json: datosUsu,
		});
		if (res?.estado ?? true) return setMensaje("Se ha producido un error"); //error
		if (res?.mensaje !== "OK" ?? false)
			return setMensaje(
				res?.mensaje ?? "Error al cambiar el usuario " + usuario + ""
			); //errores
		setDatosUsuCopy({ ...datosUsu });
		return 0;
	};

	/**
	 * Resetea la contraseña del usuario
	 * @returns 0 si todo ha ido bien, otra cosa si ha habido algún error
	 */
	const resetPassUsu = async () => {
		const res = await peticion(`/reset_pass?usuario=${datosUsu.cod_usuario}`, { method: "GET" });
		if (res?.estado ?? true) return setMensaje("Se ha producido un error"); //error
		if (res?.mensaje !== "OK" ?? false)
			return setMensaje(
				res?.mensaje ?? "Error al resetear la contraseña del usuario " + usuario + ""
			); //errores
		return 0;
	};

	/**
	 * Crea un nuevo usuario
	 * @returns 0 si todo ha ido bien, otra cosa si ha habido algún error
	 */
	const crearUsu = async () => {
		setError(null);
		const res = await peticion(`/crear_usuario`, {
			method: "POST",
			json: datosUsu,
		});
		if (res?.estado ?? true) return setMensaje("Se ha producido un error" + res.mensaje); //error
		if (res?.mensaje !== "OK" ?? false)
			return setMensaje(
				res?.mensaje ??
					"Error al crear el usuario " + datosUsu.nombre_usuario + ""
			); //errores
		return 0;
	};

	/**
	 * Elimina un usuario
	 * @returns 0 si todo ha ido bien, otra cosa si ha habido algún error
	 */
	const eliminarUsu = async () => {
		const res = await peticion(`/eliminar_usuario`, {
			method: "POST",
			json: { usuario: datosUsu.cod_usuario },
		});
		if (res?.estado ?? true) return setMensaje("Se ha producido un error. " + res.mensaje); //error
		if (res?.mensaje !== "OK" ?? false)
			return setMensaje(
				res?.mensaje ??
					"Error al eliminar el usuario " + datosUsu.nombre_usuario + ""
			); //errores
		return 0;
	};

	/**
	 * Genera las opciones del select de departamentos de forma recursiva, anidando los hijos
	 * @param {Object} departamentos 
	 * @param {Number} nivel 
	 * @returns 
	 */
	const generarOpcionesSelect = (departamentos, nivel = 0) => {
		const tab = String.fromCharCode(0x2003).repeat(nivel); //añade tabulaciones según el nivel
		return departamentos.map(departamento => {
			if(departamento.cod_ent !== datosUsu.cod_ent || departamento.cod_emp !== datosUsu.cod_emp) return null;
			return (
				<React.Fragment key={departamento.cod_dpto + departamento.cod_ent + departamento.cod_emp}>
					<option value={departamento.cod_dpto}>
						{tab}{`${departamento.nombre_dpto} `}({`${departamento.cod_dpto}`})
					</option>
					{departamento.hijos && departamento.hijos.length > 0 &&
						generarOpcionesSelect(departamento.hijos, nivel + 1)}
				</React.Fragment>
			);
		});
	}

	return (
		<>
			<div className="col-xs-12 tabla" id="user-mng">
				{tipo_usuario !== "1" &&
					<div
						className="breadcrumbs"
					>
						<span 
						onClick={() => {
							navigate("/administracion/usuarios");
						}}>Usuarios</span>
						/ {nuevo ? "Nuevo usuario" : datosUsu?.cod_usuario.toString()}
					</div>
				}
				<div className="section-header">
					<div className="button-container" id="admin-nav-menu"></div>
					<div className="img-container">
						<img src={usuariosIcon} alt=""></img>
					</div>
					<div>
						<h2>Perfil</h2>
						<h3>
							{/* <strong>Listado</strong> /  */}
							{nuevo ? "Nuevo usuario" : datosUsu?.cod_usuario ?? ""}
						</h3>
					</div>
				</div>
				<main>
					{!datosUsu && !mensaje ? ( //si no hay datos ni mensaje, está cargando
						<h1 className="cargando">Cargando...</h1>
					) : mensaje ? ( //si hay mensaje, muestra el mensaje (error)
						<h1 className="cargando">{mensaje}</h1>
					) : (
						//si hay datos, muestra los datos
						<>
							<form>
								<div className="form-item">
									<label>Código de usuario</label>
									<input
										type="text"
										placeholder="Código de usuario"
										value={datosUsu?.cod_usuario ?? ""}
										disabled={nuevo ? false : true}
										className={nuevo ? "" : "disabled"}
										maxLength={16}
										onChange={(e) =>
											setDatosUsu({ ...datosUsu, cod_usuario: e.target.value })
										}
									/>
								</div>
								<div className="form-item">
									<label>Nombre del usuario</label>
									<input
										type="text"
										placeholder="Nombre del usuario"
										value={datosUsu?.nombre_usuario ?? ""}
										disabled={tipo_usuario === "1" ? true : false}
										className={tipo_usuario === "1" ? "disabled" : ""}
										maxLength={30}
										onChange={(e) =>
											setDatosUsu({
												...datosUsu,
												nombre_usuario: e.target.value,
											})
										}
									/>
								</div>
								<div className="form-item">
									<label>NIF</label>
									<input
										type="text"
										placeholder="NIF"
										value={datosUsu?.nif_usuario ?? ""}
										disabled={tipo_usuario !== "5" ? true : false}
										className={tipo_usuario !== "5" ? "disabled" : ""}
										maxLength={10}
										onChange={(e) =>
											setDatosUsu({ ...datosUsu, nif_usuario: e.target.value })
										}
									/>
								</div>
								<div className="form-item">
									<label>Código de entidad</label>
									<select
										type="text"
										placeholder="Código de entidad"
										value={datosUsu?.cod_ent ?? ""}
										disabled={tipo_usuario === "1" ? true : false}
										className={""}
										maxLength={4}
										onChange={(e) =>
											setDatosUsu({ ...datosUsu, cod_ent: e.target.value, cod_emp: "", cod_dpto: "" })
										}
									>
										<option value="">Selecciona una entidad</option>
										{datosEntidades &&
											datosEntidades.map((entidad) => (
												<option value={entidad.cod_ent} key={entidad.cod_ent}>
													{entidad.nombre_ent} ({entidad.cod_ent})
												</option>
											))}
									</select>
								</div>
								<div className="form-item">
									<label>Código de empresa</label>
									<select
										type="text"
										placeholder="Código de empresa"
										value={datosUsu?.cod_emp ?? ""}
										disabled={tipo_usuario === "1" ? true : false}
										className={""}
										maxLength={10}
										onChange={(e) =>
											setDatosUsu({ ...datosUsu, cod_emp: e.target.value, cod_dpto: "" })
										}
									>
										<option value="">Selecciona una empresa</option>
										{datosEmpresas &&
											datosEmpresas
												.filter((empresa) => empresa.cod_ent === datosUsu.cod_ent)
												.map((empresa) => (
													<option value={empresa.cod_emp} key={empresa.cod_emp}>
														{empresa.nombre_emp} ({empresa.cod_emp})
													</option>
												))}
									</select>
								</div>
								<div className="form-item">
									<label>Código de departamento</label>
									<select
										type="text"
										placeholder="Código de departamento"
										value={datosUsu?.cod_dpto ?? ""}
										disabled={tipo_usuario === "1" ? true : false}
										className={""}
										maxLength={12}
										onChange={(e) =>
											setDatosUsu({ ...datosUsu, cod_dpto: e.target.value })
										}
									>
									<option value="">Selecciona un departamento</option>
									{datosDepartamentos &&
										// datosDepartamentos
										// 	.filter(
										// 		(departamento) =>
										// 			departamento.cod_ent === datosUsu.cod_ent &&
										// 			departamento.cod_emp === datosUsu.cod_emp
										// 	)
										// 	.map((departamento) => (
										// 		<option value={departamento.cod_dpto} key={departamento.cod_dpto}>
										// 			{departamento.nombre_dpto}
										// 		</option>
										// 	))}
										generarOpcionesSelect(datosDepartamentos)
									}
									</select>
								</div>
								<div className="form-item">
									<label>E-mail</label>
									<input
										type="text"
										placeholder="E-mail"
										value={datosUsu?.email ?? ""}
										disabled={tipo_usuario !== "5" ? true : false}
										className={tipo_usuario !== "5" ? "disabled" : ""}
										maxLength={50}
										onChange={(e) =>
											setDatosUsu({ ...datosUsu, email: e.target.value })
										}
									/>
								</div>
								{/* si soy yo mismo, no puedo cambiarme el tipo */}
								{ usuario !== id_usuario &&
									<div className="form-item">
										<label>Tipo de usuario</label>
										<select
											type="text"
											placeholder="Tipo de usuario"
											value={datosUsu?.tipo_usuario ?? ""}
											disabled={tipo_usuario === "1" ? true : false}
											className={""}
											maxLength={1}
											onChange={(e) =>
												setDatosUsu({ ...datosUsu, tipo_usuario: e.target.value })
											}
										>
											<option value="">Selecciona un tipo de usuario</option>
											{tipo_usuario==='5' && <option value="5">Administrador</option>}
											{tipo_usuario==='5' && <option value="0">Entidad</option>}
											{['5', '0'].includes(tipo_usuario) && <option value="3">Empresa</option>}
											{['5', '0', '3'].includes(tipo_usuario) && <option value="2">Departamento</option>}
											{['5', '0', '3', '2', '1'].includes(tipo_usuario) && <option value="1">Usuario</option>}
										</select>
									</div>
								}
								{!nuevo && (
									<div className="form-item">
										<label>Fecha de alta</label>
										<input
											type="text"
											placeholder="Fecha de alta"
											value={
												formatFecha(
													datosUsu.fecha_alta_usu,
													"ISO8601",
													"esp"
												) ?? "No hay fecha de alta"
											}
											disabled={true}
											className={"disabled"}
											onChange={(e) => {}}
										/>
									</div>
								)}
							</form>
							{!nuevo &&
								<>
									<label>Tarjetas</label>
									<div className="col-xs-12 cabeceratabla">
										<div className="col-xs-12 cont_cabeceratabla">
											<table>
												<tbody>
													<tr>
														<td>
															Número de tarjeta
														</td>
														<td>
															Código de entidad
														</td>
														<td>
															Código de empresa
														</td>
														<td>
															Código de departamento
														</td>
														<td>
															Nº identificación de tarjeta
														</td>
														<td>
															Fecha de alta
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
									<div className='tabladatos'>
										<div className="col-xs-12 cont_tabladatos">

											{!datosTarj ?
												<h1 className="cargando">Cargando...</h1>
											:
												datosTarj.length === 0 ?
													<h1 className="cargando">No hay tarjetas asociadas</h1>
											:
												<table>
													<tbody>
														{
															datosTarj
																.map((tarjeta, index) => (

																	<tr 
																		key={index} 
																		// onClick={() => { navigate('/tarjeta/' + tarjeta.pan) }}
																	>
																		<td>
																			<div>
																				{tarjeta.pan_mask}
																			</div>
																		</td>
																		<td>
																			<div>
																				{tarjeta.cod_ent}
																			</div>
																		</td>
																		<td>
																			<div>
																				{tarjeta.cod_emp}
																			</div>
																		</td>
																		<td>
																			<div>
																				{tarjeta.cod_dpto}
																			</div>
																		</td>
																		<td>
																			<div>
																				{tarjeta.nif_tarjeta}
																			</div>
																		</td>
																		<td>
																			<div>
																				{formatFecha(tarjeta.fecha_alta.toString(), "ISO8601", "esp")}
																			</div>
																		</td>
																	</tr>
																))
														}
													</tbody>
												</table>
											}
										</div>
									</div>
								</>
							}
							<div className="button-container">
								{!nuevo ? (
									<>
										<button
											className={
												datosUsuCopy &&
												datosUsu &&
												Object.keys(getDiferentes(datosUsuCopy, datosUsu))
													.length === 0
													? "cta desactiva"
													: "cta"
											}
											onClick={() => { if (comprobarCampos()) setmodalModificar(true); }}
										>
											Guardar
										</button>
										{/* cambio de contraseña solo si me la cambio a mi mismo, sino resetear */}
										{id_usuario === usuario ?
											<button 
												onClick={() => setModalCambioPass(true)}
											>
												Cambiar contraseña
											</button>
										:
											<button 
												onClick={() => setmodalReset(true)}
											>
												Resetear contraseña
											</button>
										}
										{/* solo puedo borrar usuarios si no soy tipo 1 y no es mi usuario */}
										{tipo_usuario !== "1" && usuario !== id_usuario &&
											<button onClick={() => setModalEliminar(true)}>
												Eliminar usuario
											</button>
										}
									</>
								) : (
									<button onClick={() => { if (comprobarCampos()) setmodalCrear(true) }}>
										Crear usuario
									</button>
								)}
							</div>
							<p>{error}</p>
						</>
					)}
				</main>
				{/*
					Modal de cambio de contraseña
				*/}
				<ModalCambioPass
					show={modalCambioPass}
					onHide={() => setModalCambioPass(false)}
				/>
				{/* 
					Modal de confirmación de eliminación de usuario
				*/}
				<ModalGenericoUsuario
					texto1={"¿Quiere eliminar este usuario?"}
					texto2={"Usuario eliminado correctamente"}
					texto3={"Eliminar usuario"}
					setMensaje={setMensaje}
					navegar={() => navigate("/administracion/")}
					navegarError={() => navigate("/perfil/" + datosUsu.cod_usuario)}
					show={modalEliminar}
					onHide={() => setModalEliminar(false)}
					func={eliminarUsu}
				/>
				{/* 
					Modal de confirmación de creación de usuario
				*/}
				<ModalGenericoUsuario
					texto1={"¿Quiere crear este usuario?"}
					texto2={"Usuario creado correctamente"}
					texto3={"Crear usuario"}
					texto4={mensaje}
					setMensaje={setMensaje}
					navegar={() => navigate("/perfil/" + datosUsu.cod_usuario)}
					navegarError={() => navigate("/administracion/usuarios")}
					show={modalCrear}
					onHide={() => setmodalCrear(false)}
					func={crearUsu}
				/>
				{/* 
					Modal de confirmación de mod de usuario
				*/}
				<ModalGenericoUsuario
					texto1={"¿Quiere modificar este usuario?"}
					texto2={"Usuario modificado correctamente"}
					texto3={"Modificar usuario"}
					texto4={mensaje}
					setMensaje={setMensaje}
					navegar={() => navigate("/perfil/" + datosUsu.cod_usuario)}
					navegarError={() => navigate("/perfil/" + datosUsu.cod_usuario)}
					show={modalModificar}
					onHide={() => setmodalModificar(false)}
					func={modUsu}
				/>
				{/* 
					Modal de reset de contraseña
				*/}
				<ModalGenericoUsuario
					texto1={"¿Quiere resetear la contraseña de este usuario?"}
					texto2={"Contraseña reseteada correctamente. Se ha enviado un email al usuario"}
					texto3={"Resetear contraseña"}
					texto4={mensaje}
					setMensaje={setMensaje}
					navegar={() => navigate("/perfil/" + datosUsu.cod_usuario)}
					navegarError={() => navigate("/perfil/" + datosUsu.cod_usuario)}
					show={modalReset}
					onHide={() => setmodalReset(false)}
					func={resetPassUsu}
				/>
			</div>
		</>
	);
};

export default PerfilUsuario;
